import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { AuthService } from "../../app/auth/auth.service";
import ContentWrapper from "../../models/content-wrapper/content-wrapper";
import Person from "../../models/person";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class CompanyDataService {
  private idgDataUrl: string;

  constructor(
    private authSvc: AuthService,
    private http: HttpClient,
    private config: ConfigurationService
  ) {
    this.idgDataUrl = config.resolveIdgUrl();
  }

  public getPhysicians(): Observable<ContentWrapper<Person>> {
    return this.http.get<ContentWrapper<Person>>(
      `${this.idgDataUrl}/company-resources/persons/physicians`,
      { params: new HttpParams().set("size", "9999") } // TODO: Maybe this should be a search field.
    );
  }

  public getPerson(id): Observable<ContentWrapper<Person>> {
    return this.http.get<ContentWrapper<Person>>(
      `${this.idgDataUrl}/company-resources/persons/${id}`
    );
  }

  ionViewCanEnter() {
    return this.authSvc.authenticated();
  }
}



// WEBPACK FOOTER //
// ./src/providers/company-data-service/company-data-service.ts